import { Modal } from 'antd';
import { useRef } from 'react';

export type DurationChange = 'removed' | 'changed';

type Props = {
  change: DurationChange | null;
  onConfirm: () => void;
  onCancel: () => void;
  endsNextDay: boolean;
};

export const DurationChangeModal = ({
  change,
  onConfirm,
  onCancel,
  endsNextDay,
}: Props) => {
  const lastChange = useRef<DurationChange>('changed');

  if (change) {
    lastChange.current = change;
  }

  return (
    <Modal
      title="Attention : This change will impact time slots"
      open={change !== null}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Confirm"
      cancelText="Cancel"
      closable={true}
      width={620}
    >
      {lastChange.current === 'removed' ? (
        <div>
          <p>
            Removing the experience duration will impact the hotel's Extranet
            schedule.
          </p>
          <br />
          <p>
            The end time of existing time slots will be kept and become editable
            in the Extranet.
          </p>
        </div>
      ) : (
        <div>
          <p>
            Changing the experience duration will impact the hotel's Extranet
            schedule.
          </p>
          <br />
          <p>
            The end time of all existing and future time slots will be
            automatically updated to match the new duration.
            {endsNextDay &&
              ` Time slots whose
            new end time goes past midnight will end the next day.`}
          </p>
          <br />
          <p>
            Please review the Extranet schedule afterward to ensure all time
            slots are still correct.
          </p>
        </div>
      )}
    </Modal>
  );
};
